import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Blog, BlogDetails } from "../../../Constant";
import MarkjencoBlog from "./MarkjencoBlog";
import BlogWithDetails from "./BlogWithDetails";
import BlogWithoutDetails from "./BlogWithoutDetails";

const BlogDetailsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={BlogDetails} parent={Blog} title={BlogDetails} />
      <Container fluid>
        <Row>
          <MarkjencoBlog />
          <BlogWithDetails />
          <BlogWithoutDetails/>
        </Row>
      </Container>
    </>
  );
};

export default BlogDetailsContainer;
